import { graphql } from '../../../graphql/generated';

export const CREATE_THEME_MUTATION = graphql(`
  mutation CreateTheme($input: ThemeInput!) {
    createTheme(input: $input) {
      id
    }
  }
`);
